
import { createContext, useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LoginLayout from "layouts/login"
import AccountService from "services/account";
import AppLoader from "components/app-loader";
import { Button, notification, Space, App, Modal, Spin, Input, Form } from 'antd';
import { useForm } from "antd/es/form/Form";
const accountService = new AccountService();

const AppContext = createContext();

function AppProvider({ children }) {
    const { message, notification } = App.useApp();
    const [modal, contextHolder] = Modal.useModal();
    const [loading, showLoading] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const [promptProps, setPromptProps] = useState({})
    const pormptInputRef = useRef();
    const pormptOnOkRef = useRef();
    const pormptOnCancelRef = useRef();
    const [form] = useForm();
    // const [api, contextHolder] = notification.useNotification();
    const showNotify = (message) => {
        notification.info({ description: message })

    }

    const createPormpt = ({ title = "Thêm mới", label = "", value = "", onOk = () => { }, onCancel = () => { } }) => {
        setShowPrompt(true);
        // pormptInputRef.current.input.value = value;
        // pormptOnOkRef.current = onOk;
        // pormptOnCancelRef.current = onCancel;
        setPromptProps({
            title, label, onOk, onCancel
        })
        form.setFieldsValue({ value: value })
    }

    const onPromptCancel = () => {
        setShowPrompt(false);
        if (promptProps.onCancel) {
            promptProps.onCancel()
        }

    }



    const onFinish = (values) => {

        if (promptProps.onOk) {
            promptProps.onOk(values.value)
        }
        setShowPrompt(false);

    }
    const onFinishFailed = (error) => {

    }





    return <AppContext.Provider value={{ showNotify, message, notification, modal, loading, showLoading, prompt: createPormpt }}>
        {children}
        {contextHolder}
        <Modal open={loading} maskClosable={false} closable={false} footer={false} width={100} zIndex={1100} >
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Spin tip="Loading" size="small">

                </Spin>
            </div>

        </Modal>

        <Modal title={promptProps.title} open={showPrompt} maskClosable={false} closable={true} onCancel={onPromptCancel} onOk={e => { form.submit() }} zIndex={1099} >
            <Form
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}

            >
                <Form.Item
                    label={promptProps.label}
                    name="value"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập tên thuộc tính cha",
                        },
                    ]}
                >
                    <Input></Input>
                </Form.Item>
            </Form>
        </Modal>
    </AppContext.Provider>;
}

const useApp = () => {
    const context = useContext(AppContext);
    return context;
};

export { useApp };
export default AppProvider;
